import React from "react";
import Chip from "@material-ui/core/Chip";
import { makeStyles } from "@material-ui/core/styles";
const useStyles = makeStyles((theme) => ({
  root: {
    flexWrap: "wrap",
    "& > *": {
      margin: theme.spacing(0.5),
    },
  },
  chip: {
    fontSize: 12,
    backgroundColor: "#fff",
    color: "#1B2027",
    borderColor: "#fff",
  },
  clear: {
    backgroundColor: "#fff",
    color: "#000000",
    cursor: "pointer",
    // "&:hover, &:focus": {
    //   backgroundColor: "#1B2027 !important",
    // },
  },
  selectedChips: {
    fontSize: 12,
    backgroundColor: "#56CDE8",
    color: "#FFFFFF",
    borderColor: "#56CDE8",
    "&:hover, &:focus": {
      backgroundColor: "#56CDE8 !important",
    },
  },
}));

const MultiSelectChips = ({
  label,
  id,
  deleteHandler,
  clickHandler,
  deletable,
  selected_id,
  chipdata,
}) => {
  const classes = useStyles();

  const renderChips = () => {
    return (
      <Chip
        key={id}
        // className={"m-1 " + (deletable ? classes.selectedChips : classes.clear)}
        className={
          id == selected_id
            ? `${classes.selectedChips}   ${classes.clear}`
            : classes.chip
        }
        label={label}
        variant="outlined"
        onDelete={deletable ? () => deleteHandler(id) : undefined}
        onClick={() => clickHandler(chipdata)}
      />
    );
  };

  return <>{renderChips()}</>;
};
export default MultiSelectChips;
